<template>
  <li class="store_list pnt" @click="goDetail">
    <div class="base">
      <div class="list_thumb">
        <div class="n_thumb">
          <div class="n_thumb_inner">
            <img v-if="data.storeProfile" :src="data.storeProfile" alt="" />
            <img v-else :src="setShopProfileImg(data.name, data.id)" alt="" />
          </div>
        </div>
      </div>
      <div class="store_info">
        <div class="ttl">
          <h1 v-html="colorWord(data.name)"></h1>
        </div>
        <div class="shop_index_wrap">
          <div class="shop_index">
            <dl>
              <dt><i class="i_chart"></i>응답률</dt>
              <dd>{{ convertRate(data) }}{{ convertTime(data) }}</dd>
              <dt><i class="i_chat"></i>상담</dt>
              <dd>{{ data.chatCnt }}건</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { setKeyword, setShopProfile } from '@common/lib/common/utils';

export default {
  name: 'component-search-store-item',
  description: '검색 페이지 > 매장 아이템',
  props: {
    data: Object,
  },
  methods: {
    goDetail() {
      this.$router.push({
        name: 'Shops.Detail',
        params: { id: this.data.id },
      });
    },
    convertRate(data) {
      if (data.chatCnt > 0 && data.responseRate > 0) {
        return `${data.responseRate > 100 ? 100 : data.responseRate}%`;
      }
      return '-';
    },
    convertTime(data) {
      if (data.chatCnt > 0 && data.responseRate > 0) {
        let result = '';
        if (data.responseMinute >= 0 && data.responseMinute <= 10) {
          result = '(10분 이내)';
        } else if (data.responseMinute > 10 && data.responseMinute <= 30) {
          result = '(30분 이내)';
        } else if (data.responseMinute > 30 && data.responseMinute <= 60) {
          result = '(1시간 이내)';
        } else if (data.responseMinute > 60 && data.responseMinute <= 120) {
          result = '(2시간 이내)';
        } else if (data.responseMinute > 120 && data.responseMinute <= 360) {
          result = '(6시간 이내)';
        } else if (data.responseMinute > 360) {
          result = '(6시간 이상)';
        }
        return result;
      }
      return '';
    },
    colorWord(content) {
      const keyword = this.$route.query.keyword;
      return setKeyword(content, keyword);
    },
    setShopProfileImg(shopName, shopId) {
      let path = setShopProfile(shopName, shopId, '140x140');

      return path;
    },
  },
};
</script>
